module.exports = __webpack_public_path__ + "assets/img/gzh.a7fae928.jpg";